import React from 'react';
import '../styles/ClientLogos.css';
import rawClientData from '../assets/rawClientData.json';

const loadLogo = (shortName) => {
  try {
    return require(`../assets/logos/${shortName}.png`);
  } catch {
    return null;
  }
};

const clientData = Object.fromEntries(
  Object.entries(rawClientData).map(([category, clients]) => [
    category,
    clients.map((client) => ({
      ...client,
      logo: loadLogo(client.shortName)
    }))
  ])
);

const ClientLogos = ({ category }) => {
  // Kategori belirtilmemişse tüm müşterileri göster
  const clients = category ? clientData[category] : Object.values(clientData).flat();

  return (
    <div className="client-logos-section">
      <div className="container">
        <div className="client-logos-grid">
          {clients.map((client, index) => (
            <div className="client-logo-item" key={index}>
              {client.logo ? (
                <img src={client.logo} alt={client.shortName} />
              ) : (
                <div className="client-logo-placeholder">
                  <span>{client.shortName}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientLogos;